import { createAsyncThunk } from "@reduxjs/toolkit";
import { apiFetch } from '@/lib/api-fetch';
import cryptographerService from "../../services/cryptographer-service";
import { deleteVault } from "../../utils/vault-storage";

interface DeleteVaultParams {
  vaultId: string;
}

export const deleteVaultThunk = createAsyncThunk<string, DeleteVaultParams>(
  'vault/deleteVault',
  async (params) => {
    const { vaultId } = params;

    // Attempt to delete from server (don't fail if this doesn't work)
    try {
      const response = await apiFetch(`/api/vaults/${vaultId}`, {
        method: 'DELETE',
        headers: {
          'Accept': 'application/json'
        }
      });
      
      if (response.ok) {
        console.log(`[Delete Vault Thunk] Successfully deleted vault ${vaultId} from server`);
      } else {
        console.warn(`[Delete Vault Thunk] Failed to delete vault ${vaultId} from server:`, response.status, response.statusText);
      }
    } catch (error) {
      console.warn(`[Delete Vault Thunk] Error calling delete API for vault ${vaultId}:`, error);
      // Continue with local deletion even if API call fails
    }

    // Remove all vault data from localStorage
    deleteVault(vaultId);

    // Clear the cryptographer for this vault
    if (cryptographerService.hasCryptographer(vaultId)) {
      cryptographerService.clearCryptographer(vaultId);
    }

    // Return the deleted vault ID for state cleanup
    return vaultId;
  }
);